module.exports = "https://web-assets.ifttt.com/packs/media/service-previews/google-drive-icon-f9193427.png";